import { createContext, useEffect, useState } from 'react';

import { useOktaAuth } from '@okta/okta-react';

import APIClient from '../APIClient';
import APIService from '../APIService';

export const APIContext = createContext();

export default function Provider({ children }) {
  const [data, setData] = useState({});
  const [isAuthenticated, setAuth] = useState(false);

  const { oktaAuth } = useOktaAuth();
  useEffect(() => {
    oktaAuth.tokenManager.getTokens().then(res => {
      setData(res.accessToken);
    });
    oktaAuth.isAuthenticated().then(res => setAuth(res));
  }, [oktaAuth]);
  // Instatiation of the APIClient with access token
  const apiClient = new APIClient(data, oktaAuth);
  // Instatiation of the APIService singleton
  const apiService = new APIService(apiClient);

  // APIContext provider that provides the apiService singleton to all of its children
  return <APIContext.Provider value={{ apiService, isAuthenticated }}>{children}</APIContext.Provider>;
}
